import { Component, OnInit, ViewChild } from '@angular/core';
import { Proceso, Empresa } from '../../classes/coordinador';
import { FiltrosComponent } from '../filtros/filtros.component';
import { isDefined } from '@angular/compiler/src/util';
import { AWSService } from '../../shared/services/aws.service';
import { ApiEmpresasService } from '../../shared/services/api-empresas.service';
import { ApiDocumentosService } from '../../shared/services/api-documentos.service';
import { ApiProcesosService } from '../../shared/services/api-procesos.service';
import { AppStorage } from 'src/app/shared/services/appStorage.service';
import { MatDialog } from '@angular/material';
import { ModalConfirmacionComponent } from 'src/app/shared/components/modal-confirmacion/modal-confirmacion.component';

@Component({
  selector: 'app-carga',
  templateUrl: './carga.component.html',
  styleUrls: ['./carga.component.css']
})
export class CargaComponent implements OnInit {
  @ViewChild(FiltrosComponent)
  filtrosComponent: FiltrosComponent;

  // Data
  procesos: Proceso[];
  empresas: Empresa[];
  procesoAux;
  archivo: any;

  // Loading
  loadingEmpresas = true;
  loadingProcesos = true;
  loadingDropArchivo = false;
  loadingPublicar = false;
  error = false;

  // Estados
  estadoCarga = 'init';
  msjErrorValidacion = '';

  constructor(
    private awsService: AWSService,
    private apiEmpresasService: ApiEmpresasService,
    private apiProcesosService: ApiProcesosService,
    private apiDocumentoService: ApiDocumentosService,
    public dialog: MatDialog,
    public appStorage: AppStorage
  ) {}

  ngOnInit() {
    this.cargarProcesos();
    this.cargarEmpresas();
  }

  mostrarCargaDeArchivos() {
    if (this.filtrosComponent) {
      return (
        isDefined(this.filtrosComponent.filtrosSeleccionados.anno) &&
        isDefined(this.filtrosComponent.filtrosSeleccionados.mes) &&
        isDefined(
          this.filtrosComponent.filtrosSeleccionados.plazoCargaEmpresa
        ) &&
        isDefined(this.filtrosComponent.filtrosSeleccionados.proceso) &&
        isDefined(this.filtrosComponent.filtrosSeleccionados.empresa)
      );
    }

    return false;
  }

  dropped(event) {
    // reiniciar estados
    this.archivo = undefined;
    this.estadoCarga = 'init';
    this.loadingDropArchivo = true;

    // Validar si se sube un solo archivo
    if (event.files.length !== 1) {
      this.estadoCarga = 'errorValidacion';
      this.msjErrorValidacion = 'Solo puede subir un archivo';
      this.loadingDropArchivo = false;
      return;
    }

    this.archivo = event.files[0];

    // Validar extension xlsx
    const nombreArchivo: string = this.archivo.relativePath;
    let nombreSinExtension = '';
    let extension = '';
    if (nombreArchivo.lastIndexOf('.') > 0) {
      nombreSinExtension = nombreArchivo.substr(
        0,
        nombreArchivo.lastIndexOf('.')
      );
      extension = nombreArchivo.substr(
        nombreArchivo.lastIndexOf('.') + 1,
        nombreArchivo.length - nombreArchivo.lastIndexOf('.')
      );
    } else {
      // archivo sin extension
      this.estadoCarga = 'errorValidacion';
      this.msjErrorValidacion = 'Solo puede subir archivos con formato .xlsx';
      this.loadingDropArchivo = false;
      return;
    }

    if (extension !== 'xlsx') {
      // archivo sin extension
      this.estadoCarga = 'errorValidacion';
      this.msjErrorValidacion = 'Solo puede subir archivos con formato .xlsx';
      this.loadingDropArchivo = false;
      return;
    }

    // Crear nombre
    this.apiDocumentoService
      .getDocumentosCargaCoordinador(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso,
        'Publicado'
      )
      .then((archivos: any) => {
        const nombreArchivoSinVersion = this.crearNombreArchivoSinVersion();

        if (archivos.length === 0) {
          this.archivo.nombreAPublicar = 'VE01_' + nombreArchivoSinVersion;
        } else {
          this.archivo.nombreAPublicar =
            'VE' +
            this.obtenerVersion(archivos, nombreArchivoSinVersion) +
            '_' +
            nombreArchivoSinVersion;
        }
        this.mostrarModalConfirmacion();
        this.loadingDropArchivo = false;
      })
      .catch(error => {
        this.estadoCarga = 'error';
        this.loadingDropArchivo = false;
      });
  }

  obtenerVersion(archivos, nombreArchivoSinVersion) {
    let versionMasAlta = 0;

    for (const archivo of archivos) {
      if (
        archivo.nombreArchivo.indexOf('VE') > -1 &&
        archivo.nombreArchivo.indexOf(nombreArchivoSinVersion) > -1
      ) {
        const versionTmp = parseInt(archivo.nombreArchivo.substr(2, 2), 0);
        if (versionMasAlta < versionTmp) {
          versionMasAlta = versionTmp;
        }
      }
    }

    if (versionMasAlta < 9) {
      return '0' + (versionMasAlta + 1);
    } else {
      return versionMasAlta + 1 + '';
    }
  }

  crearNombreArchivoSinVersion() {
    return (
      'FIFC_' +
      this.filtrosComponent.filtrosSeleccionados.empresa.sigla +
      '_' +
      this.filtrosComponent.filtrosSeleccionados.proceso.sigla +
      this.filtrosComponent.filtrosSeleccionados.mes.sigla +
      this.filtrosComponent.filtrosSeleccionados.anno +
      '.xlsx'
    );
  }

  publicarArchivoEmpresa() {
    this.loadingPublicar = true;
    this.estadoCarga = 'publicando';

    this.awsService
      .publicarArchivoEmpresa(
        this.archivo,
        this.archivo.nombreAPublicar,
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.sigla,
        this.filtrosComponent.filtrosSeleccionados.proceso.sigla
      )
      .then((res: any) => {
        this.archivo.url = res.location;
        this.apiDocumentoService
          .publicarDocumentos(
            this.filtrosComponent.filtrosSeleccionados.empresa,
            this.filtrosComponent.filtrosSeleccionados.proceso,
            this.filtrosComponent.filtrosSeleccionados.anno,
            this.filtrosComponent.filtrosSeleccionados.mes.numero,
            this.filtrosComponent.filtrosSeleccionados.plazoCargaEmpresa,
            this.archivo
          )
          .then(resIFCDoc => {
            this.estadoCarga = 'publicado';
            this.loadingPublicar = false;
          })
          .catch(error => {
            this.estadoCarga = 'error';
            this.loadingPublicar = false;
            console.error(error);
          });
      })
      .catch(error => {
        this.estadoCarga = 'error';
        this.loadingPublicar = false;

        console.log(error);
      });
  }

  mostrarModalConfirmacion() {
    const dialogRef = this.dialog.open(ModalConfirmacionComponent, {
      width: '350px',
      data: {
        icon: 'error_outline',
        texto:
          'Estimado usuario ¿Desea publicar el archivo ' +
          this.archivo.nombreAPublicar +
          '?',
        textoBoton: 'Aceptar',
        callback: () => {
          this.publicarArchivoEmpresa();
          dialogRef.close();
        }
      }
    });
  }

  volverACargar() {
    this.archivo = undefined;
    this.estadoCarga = 'init';
    this.loadingDropArchivo = false;

    if (
      isDefined(this.filtrosComponent.filtrosSeleccionados.anno) &&
      isDefined(this.filtrosComponent.filtrosSeleccionados.mes) &&
      isDefined(this.filtrosComponent.filtrosSeleccionados.proceso)
    ) {
      this.getProcesoMes();
    }
  }

  getProcesoMes() {
    this.procesoAux = undefined;
    this.appStorage.loadingGeneral = true;
    this.apiProcesosService
      .getProcesoMes(
        this.filtrosComponent.filtrosSeleccionados.anno,
        this.filtrosComponent.filtrosSeleccionados.mes.numero,
        this.filtrosComponent.filtrosSeleccionados.proceso
      )
      .then((res: any) => {
        if (res) {
          this.getValidarPermisoEmpresa();
          this.procesoAux = res;
          this.filtrosComponent.cargarFechas(
            res.plazoMaxCoordinador,
            res.plazoMaxEmpresa,
            res.estado
          );
        } else {
          this.filtrosComponent.cargarFechas();
          this.procesoAux = 'sin_proceso';
        }
        this.filtrosComponent.procesoAux = this.procesoAux;
        this.appStorage.loadingGeneral = false;
      })
      .catch(error => {
        this.appStorage.loadingGeneral = false;
      });
  }


  getValidarPermisoEmpresa() {
    const mes = this.filtrosComponent.filtrosSeleccionados.mes.numero;
    const proceso = this.filtrosComponent.filtrosSeleccionados.proceso;
    const annio = this.filtrosComponent.filtrosSeleccionados.anno;

    this.apiDocumentoService.getDocumentosCargaCoordinador(annio, mes, proceso, 'Publicado')
    .then(response => {

      const siglaEmpresaSeleccionada = this.filtrosComponent.filtrosSeleccionados.empresa.sigla;
      let permiso: boolean;
      for (const key in response) {
        if (response.hasOwnProperty(key)) {
          const doc = response[key];
          const ultimaParte = doc.nombreArchivo.substr(-17, 17);
          const empresa = doc.nombreArchivo.substring(10, doc.nombreArchivo.indexOf(ultimaParte));

          if (siglaEmpresaSeleccionada === empresa) {
            permiso = true;
            if (doc.version.substr(0, 2) === 'VC') {
              permiso = true;
              break;
            } else {
              permiso = false;
            }
          } else {
            permiso = false;
          }


        }
      }

      if (!permiso) {
        this.estadoCarga = 'errorPermisos';
      }

    })
    .catch(err => {
      console.log('error ==>   ', err);

    });
  }

  cargarProcesos() {
    this.apiProcesosService
      .getProcesosActivos()
      .then((res: any) => {
        if (res === null || !res) {
          this.procesos = [];
        } else {
          this.procesos = res;
        }
        this.procesos.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingProcesos = false;
      })
      .catch(error => {
        this.error = true;
        this.loadingProcesos = false;
        console.error(error);
      });
  }

  cargarEmpresas() {
    this.apiEmpresasService
      .getEmpresasUsuarioEmpresa()
      .then((res: any) => {
        // descomentar la linea de abajo y borrar la asignacion de empresas desde el mock
        this.empresas = res;


        this.empresas = this.empresas.filter(item => item.sigla !== null);
        this.empresas.sort(function(a, b) {
          if (a.sigla < b.sigla) {
            return -1;
          }
          if (a.sigla > b.sigla) {
            return 1;
          }
          return 0;
        });
        this.loadingEmpresas = false;
      })
      .catch(error => {
        this.error = true;
        this.loadingEmpresas = false;
        console.error(error);
      });
  }
}
